export enum UserRoles {
	superAdmin = 49,
	admin = 3,
	liquidBulk = 17,
}
